import TicketFilters from './TicketFilters';
import TicketCard from './TicketCard';
import { SupportTicket, FilterOption } from '../../utils/types';

interface TicketListProps {
  tickets: SupportTicket[];
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedCategory: string;
  onCategoryChange: (value: string) => void;
  selectedPriority: string;
  onPriorityChange: (value: string) => void;
  categories: FilterOption[];
  priorities: FilterOption[];
  onEditTicket?: (ticketId: string) => void;
  onDeleteTicket?: (ticketId: string) => void;
}

const TicketList = ({
  tickets,
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedPriority,
  onPriorityChange,
  categories,
  priorities,
  onEditTicket,
  onDeleteTicket,
}: TicketListProps) => {
  const filteredTickets = Array.isArray(tickets)
    ? tickets.filter(ticket => ticket.is_deleted !== true)
    : [];

  return (
    <div className="space-y-6">
      <TicketFilters
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        selectedCategory={selectedCategory}
        onCategoryChange={onCategoryChange}
        selectedPriority={selectedPriority}
        onPriorityChange={onPriorityChange}
        categories={categories}
        priorities={priorities}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {filteredTickets.map(ticket => (
          <TicketCard
            key={ticket.id}
            ticket={ticket}
            onEdit={onEditTicket}
            onDelete={onDeleteTicket}
          />
        ))}
      </div>

      {!Array.isArray(tickets) ||
        (filteredTickets.length === 0 && (
          <div className="text-center py-12">
            <p className="text-muted-foreground">
              No tickets found matching your filters.
            </p>
          </div>
        ))}
    </div>
  );
};

export default TicketList;
